import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import CurrencyCode from 'types/CurrencyCode';
import PlanCode from 'types/PlanCode';
import PlanTypeType from 'types/PlanTypeType';
import * as baseStyles from '../../../../styles/baseStyles.module.scss';
import * as formStyles from '../../styles/styles.module.scss';
import PlanTypeCardCollection from '../PlanTypeCardCollection';
import * as styles from './styles/styles.module.scss';

type Props = {
  activePlanType?: PlanCode;
  buttonText: string;
  currencyCode: CurrencyCode;
  handleClick?(...args: unknown[]): unknown;
  handleSubmit?(...args: unknown[]): unknown;
  headerText: React.ReactNode;
  isCouponApplied?: boolean;
  planTypes: PlanTypeType[];
  verifiedCoupon?: {
    code?: string;
    discountPercentage?: number;
    discountedPricePerYear?: string;
    id?: number;
    metaData?: object;
    originalPricePerYear?: string;
    type?: string;
  };
};

function PlanType({
  buttonText,
  headerText,
  planTypes,
  handleClick,
  activePlanType,
  currencyCode,
  verifiedCoupon,
  isCouponApplied,
  handleSubmit
}: Props) {
  return (
    <div className={styles.planTypeContainer}>
      <div className={(baseStyles.container, formStyles.container)}>
        {planTypes.length > 1 && <div className={styles.pickYourPlan}>{headerText}</div>}
        <div className={baseStyles.section}>
          <div className={(baseStyles.row, formStyles.group)}>
            <div className={baseStyles.row}>
              <PlanTypeCardCollection
                activePlanType={activePlanType}
                currencyCode={currencyCode}
                handler={handleClick}
                isCouponApplied={isCouponApplied}
                planTypes={planTypes}
                verifiedCoupon={verifiedCoupon}
              />
            </div>
          </div>
          <div className={baseStyles.row} data-testid="Get Started">
            <Button text={buttonText} onClick={handleSubmit} testId={buttonText} variant="primary" />
          </div>
        </div>
        <div className={styles.cancel}>
          {activePlanType === PlanCode.SevenDayTrial ? (
            <FormattedMessage defaultMessage="Cancel anytime." />
          ) : (
            <FormattedMessage defaultMessage="Cancel within 30 days and receive a full-refund." />
          )}
        </div>
      </div>
    </div>
  );
}

export default PlanType;
